export default function LoginWaitingApproval() {
  return (
    <>
        <div className="success-message">
            추가 정보가 성공적으로 제출되었습니다. 관리자 승인을 기다려 주세요.
        </div>
    </>
  );
}